/* @flow */
import * as React from 'react';
import PropTypes from 'prop-types';
import invariant from 'invariant';
import classnames from 'classnames';
import Text from 'components/Text.jsx';
import Tabs from 'components/Tabs.jsx';
import { mountModal } from 'lib/modal';
import TabPanel from 'components/TabPanel.jsx';

function Title(props: { active: boolean, children?: React.Node }) {
  const classes = classnames('NavigationTabs-tab', {
    'NavigationTabs-tab--active': props.active,
    'NavigationTabs-tab--inactive': !props.active,
  });

  return (
    <Text size="xxxsmall" smallCaps className={classes}>
      {props.children}
    </Text>
  );
}

type Tab = {
  indicator?: boolean,
  modal?: *,
  name: string,
  path?: string,
};

type Props = {
  tabs: Tab[],
};

class NavigationTabs extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  render() {
    const { tabs, ...props } = this.props;

    if (__DEV__ || __TEST__) {
      tabs.forEach(tab => {
        invariant(tab.path || tab.modal, 'NavigationTabs tab needs a path xor a modal');
        invariant(!tab.path || !tab.modal, 'NavigationTabs tab needs a path xor a modal');
      });
    }

    const activeTab = tabs.findIndex(tab => {
      return tab.path && this.context.router.isActive(tab.path);
    });

    return (
      <Tabs {...props} tabActive={activeTab} tabHeaderClass="NavigationTabs-tabHeader">
        {tabs.map((tab, index) => (
          <TabPanel
            key={tab.path}
            to={tab.path}
            disableActivationOnClick={!!tab.modal}
            indicator={tab.indicator}
            title={<Title active={index === activeTab}>{tab.name}</Title>}
            eventElementName="NavigationTabs"
            onClick={() => {
              if (tab.path) {
                this.context.router.replace(tab.path);
              }

              if (tab.modal) {
                mountModal(tab.modal, this);
              }
            }}
          />
        ))}
      </Tabs>
    );
  }
}

export default NavigationTabs;
